import { render, staticRenderFns } from "./NbTableFilters.vue?vue&type=template&id=8ce07986&scoped=true&"
import script from "./NbTableFilters.vue?vue&type=script&lang=js&"
export * from "./NbTableFilters.vue?vue&type=script&lang=js&"
import style0 from "./NbTableFilters.vue?vue&type=style&index=0&id=8ce07986&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce07986",
  null
  
)

export default component.exports